import '../BlogPost/blogpost.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { faFacebookF, faTwitter, faPinterest, faGooglePlusG} from "@fortawesome/free-brands-svg-icons";
import {faEnvelope} from "@fortawesome/free-solid-svg-icons";
import {Fragment, useEffect, useState} from "react";
import {useParams} from 'react-router-dom';
import ArticleAPI from '~/api/articleApi';
import Skeleton from "react-loading-skeleton";
import {format} from "date-fns";
function ArticlePost() {
    const {slug} = useParams();
    const [articles, setArticles] = useState(null);

    useEffect(() => {
        ArticleAPI.getDetailsByRoutePath(slug)
            .then(res => {
                res.data?.ArticleRefers.forEach(post => {
                    post.RoutePath = "/" + post.RoutePath;
                })
                setArticles(res.data);
            })
    }, [slug])

    if(!articles){
        return (
            <Fragment>
                <div id="post-header" className="page-header">
                    <div className="page-header-bg" data-stellar-background-ratio="0.5"></div>
                </div>
                <section>
                    <div className="container">
                        <Skeleton height={40} width={300} />
                        <Skeleton height={200} width="100%" />
                        <Skeleton count={3}/>
                    </div>
                </section>
            </Fragment>
        )
    }
    return (
        <Fragment>
            <div id="post-header" className="page-header">
                <div className="page-header-bg" data-stellar-background-ratio="0.5"></div>
                <div className="container">
                    <div className="row">
                        <div className="col-md-10">
                            <div className="post-category">
                                <a href="#">{articles.ArticleDetails.ArticleTypeName}</a>
                            </div>
                            <h1>{articles.ArticleDetails.Title}</h1>
                            <ul className="post-meta">
                                <li><a href="author.html">Break Through</a></li>
                                <li> {format(new Date(articles.ArticleDetails.ModifiedDate), "dd-MMMM-yyyy")}</li>
                                <li><i className="fa fa-comments"></i> 3</li>
                                <li><i className="fa fa-eye"></i> 807</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <section>
                <div className="container">
                    <div className="row">
                        <div className="col-md-8">
                            <div className="section-row">
                                <h3>{articles.ArticleDetails.Description}</h3>
                                <div
                                    dangerouslySetInnerHTML={{__html: articles.ArticleDetails.Content}}
                                />
                            </div>

                            <div className="section-row">
                                <div className="post-tags">
                                    <ul className="ps-0">
                                        <li>TAGS:</li>
                                        <li><a href="#">Love</a></li>
                                        <li><a href="#">Happiness</a></li>
                                        <li><a href="#">Money</a></li>
                                        <li><a href="#">Health</a></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="section-row">
                                <div className="post-nav">
                                    <div className="prev-post">
                                        <a className="post-img" href={articles.ArticleRefers[0].RoutePath}>
                                            <img src={articles.ArticleRefers[0].ThumbnailUrl} alt="image"/>
                                        </a>
                                        <h3 className="post-title">
                                            <a href={articles.ArticleRefers[0].RoutePath}>{articles.ArticleRefers[0].Title}</a>
                                        </h3>
                                        <span>Previous post</span>
                                    </div>

                                    <div className="next-post">
                                        <a className="post-img" href={articles.ArticleRefers[1].RoutePath}>
                                            <img src={articles.ArticleRefers[1].ThumbnailUrl} alt="image"/>
                                        </a>
                                        <h3 className="post-title">
                                            <a href={articles.ArticleRefers[1].RoutePath}>{articles.ArticleRefers[1].Title}</a>
                                        </h3>
                                        <span>Next post</span>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div className="section-title">
                                    <h3 className="title">Related Posts</h3>
                                </div>
                                <div className="row">
                                    {
                                        articles.ArticleRefers.slice(1,4).map((post, index) => {
                                            return (
                                                <div className="col-md-4" key={index}>
                                                    <div className="post post-sm">
                                                        <a className="post-img" href={post.RoutePath}>
                                                            <img src={post.ThumbnailUrl} alt="image"/>
                                                        </a>
                                                        <div className="post-body">
                                                            <div className="post-category">
                                                                <span className="fs-9 text-uppercase">{post.ArticleTypeName}</span>
                                                            </div>
                                                            <h3 className="post-title title-sm">
                                                                <a href={post.RoutePath}>{post.Title}</a>
                                                            </h3>
                                                            <ul className="post-meta ps-0 list-unstyled">
                                                                <li>BreakThrough</li>
                                                                <li>{format(new Date(post.ModifiedDate), "dd-MMMM-yyyy")}</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="aside-widget">
                                <div className="section-title">
                                    <h2 className="title">Categories</h2>
                                </div>
                                <div className="category-widget">
                                    <ul className="list-unstyled">
                                        <li><a href="#">Love <span>451</span></a></li>
                                        <li><a href="#">Happiness <span>230</span></a></li>
                                        <li><a href="#">Money <span>38</span></a></li>
                                        <li><a href="#">Health <span>24</span></a></li>
                                    </ul>
                                </div>
                            </div>

                            <div className="aside-widget">
                                <div className="section-title">
                                    <h2 className="title">Popular Posts</h2>
                                </div>
                                {
                                    articles.ArticleRefers.slice(4,8).map((post, index) => (
                                        <div className="post post-widget" key={index}>
                                            <a className="post-img" href={post.RoutePath}>
                                                <img src={post.ThumbnailUrl} alt=""/></a>
                                            <div className="post-body">
                                                <div className="post-category">
                                                    <span className="fs-9 text-uppercase">{post.ArticleTypeName}</span>
                                                </div>
                                                <h3 className="post-title">
                                                    <a href={post.RoutePath}>{post.Title}</a>
                                                </h3>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Fragment>
    )
}

export default ArticlePost;